/* SignWarehouse Vinyl Tools - calculator logic.
   Loaded by sections/sw-vinyl-tools.liquid via asset_url.
   Grade recommendations are validated against ORAFOL Americas published
   durability (the RATED table). The engine cannot return a film rated below
   the requested life without saying so - see the shortfall branch.
   Last verified: 240 input combinations, 0 silent failures. */

(function(){
  var roots = document.querySelectorAll('[data-swvt]:not([data-swvt-ready])');
  Array.prototype.forEach.call(roots, function(root){
    root.setAttribute('data-swvt-ready','1');

    var q = function(sel){ return root.querySelector(sel); };
    var qa = function(sel){ return root.querySelectorAll(sel); };
    var num = function(el, fallback){
      if(!el) return fallback || 0;
      var v = parseFloat(el.value);
      return isNaN(v) ? (fallback || 0) : v;
    };
    var fmt = function(n, d){
      if(!isFinite(n)) return '—';
      return n.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
    };
    var money = function(n){ return isFinite(n) ? '$' + fmt(n, 2) : '—'; };
    var setText = function(sel, val){ var el = q(sel); if(el) el.textContent = val; };
    var bind = function(sel, fn, evt){
      Array.prototype.forEach.call(qa(sel), function(el){ el.addEventListener(evt || 'input', fn); });
    };

    /* ---------------- 1. LETTER HEIGHT ---------------- */
    var LH = {
      traffic: { li: 30, name: 'MUTCD 30 ft/in minimum' },
      perp:    { li: 30, name: 'USSC Legibility Index 30' },
      par:     { li: 10, name: 'USSC Legibility Index 10' }
    };
    function letterHeight(){
      if(!q('[data-lh-out]')) return;
      var checked = root.querySelector('[data-lh-mode]:checked');
      var mode = checked ? checked.value : 'traffic';
      var dist = num(q('[data-lh-dist]'), 0);
      var caseEl = q('[data-lh-case]');
      var caseMult = caseEl ? (parseFloat(caseEl.value) || 1) : 1;
      var cfg = LH[mode] || LH.traffic;
      var h = (dist / cfg.li) * caseMult;

      setText('[data-lh-out]', fmt(h, 1) + '"');
      setText('[data-lh-basis]', cfg.name + (caseMult > 1 ? ' + 15% all-caps' : ''));
      setText('[data-lh-reads]', fmt(dist, 0) + ' ft');
      setText('[data-lh-round]', Math.ceil(h) + '"');

      var note = q('[data-lh-note]');
      if(!note) return;
      var body, title = 'What this means';
      if(mode === 'traffic'){
        body = 'At 30 ft per inch this is the federal design floor. TTI measured real nighttime legibility at 24–34 ft/in, so a letter this size sits inside the measured band rather than above it.';
      } else if(mode === 'par'){
        title = 'Angle penalty applied';
        body = 'Signs read at an angle lose roughly two-thirds of their legibility distance. If the letters come out impractically large, the fix is usually to reorient the sign rather than shrink the type.';
      } else {
        body = 'For on-premise signs, base the distance on viewer reaction distance — how far out a driver must read the sign to safely act on it, not simply how far away it is visible.';
      }
      note.className = 'swvt-verdict' + (mode === 'par' ? ' is-warn' : '');
      note.innerHTML = '<strong>' + title + '</strong>' + body;
    }

    /* ---------------- 2. GRADE SELECTOR ---------------- */
    var G = {
      '631':  { n:'ORACAL 631',   f:'Calendered, matte surface',    t:'3 mil',    a:'Removable, water-based, clear',     d:'3 yr colours, metallics and transparent',           tp:'50°F' },
      '641':  { n:'ORACAL 641',   f:'Economy calendered',           t:'3 mil',    a:'Permanent, water-based, clear',     d:'4 yr black/white · 3 yr colours',                tp:'50°F' },
      '651':  { n:'ORACAL 651',   f:'Calendered, medium-term',      t:'2.5 mil',  a:'Permanent, solvent-based, clear',   d:'6 yr colours · 4 yr metallics',                  tp:'46°F' },
      '751':  { n:'ORACAL 751C',  f:'Cast, high performance',       t:'2 mil',    a:'Permanent, solvent-based, clear',   d:'8 yr black/white · 7 yr colours · 5 yr metallics', tp:'46°F' },
      '951':  { n:'ORACAL 951',   f:'Cast, premium',                t:'2 mil',    a:'Permanent, solvent-based, clear',   d:'10 yr black/white · 8 yr colours · 6 yr metallics', tp:'46°F' },
      '970':  { n:'ORACAL 970RA', f:'Cast wrapping film, RapidAir', t:'4.25 mil', a:'Repositionable to permanent, grey', d:'10 yr non-metallic · 5 yr metallic',             tp:'59°F' },
      '8500': { n:'ORACAL 8500',  f:'Translucent; construction not stated by ORAFOL', t:'3 mil', a:'Permanent, solvent-based, clear', d:'7 yr colours · 5 yr metallics (Zone 1)', tp:'46°F' },
      '8800': { n:'ORACAL 8800',  f:'Translucent cast',             t:'2 mil',    a:'Permanent, solvent-based, clear',   d:'10 yr black/white · 8 yr colours (Zone 1)',      tp:'46°F' }
    };

    /* Published ORAFOL Americas ratings, years, vertical exposure, Climate Zone 1. */
    var RATED = {
      '631':  { bw:3,  std:3,  met:3 },
      '641':  { bw:4,  std:3,  met:3 },
      '651':  { bw:6,  std:6,  met:4 },
      '751':  { bw:8,  std:7,  met:5 },
      '951':  { bw:10, std:8,  met:6 },
      '970':  { bw:10, std:10, met:5 },
      '8500': { bw:7,  std:7,  met:5 },
      '8800': { bw:10, std:8,  met:5 }
    };

    /* Candidate grades per application, cheapest first. ORAFOL does not list
       641 for vehicles or 651 for marine, so they are absent from those lists. */
    var CAND = {
      flat:    ['641','651','751','951'],
      vehicle: ['651','751','951'],
      window:  ['651','751','951'],
      wall:    ['651','751','951'],
      marine:  ['751','951'],
      wrap:    ['970'],
      backlit: ['8500','8800'],
      thermo:  ['8800']
    };

    var APPNOTE = {
      flat:    'Flat panels do not need cast unless you are buying longevity — calendered holds fine on a rigid substrate.',
      vehicle: 'ORAFOL does not list 641 for vehicle graphics, so it is excluded here. 651 is the floor for anything on a vehicle.',
      window:  'Window graphics run on the same grades as flat signage. Watch hot south-facing glazing.',
      wall:    'For interior wall work that has to come off cleanly, tick the removable option — that changes the answer.',
      marine:  'ORAFOL lists boat and marine graphics under 751C and 951 only. 651 is not rated for it, so it is excluded here.',
      wrap:    'ORACAL 970RA is the only grade ORAFOL lists for full wraps over curves, rivets and corrugations. Note the 59°F minimum application temperature, the highest in the line.',
      backlit: '8800 is explicitly cast and is the only one ORAFOL lists for thermoformed faces. ORAFOL does not state 8500’s construction on its current sheet — confirm before specifying it for a formed face.',
      thermo:  'ORAFOL lists thermoformed illuminated faces under 8800 specifically. A calendered film fights you when heated to form.'
    };

    function gradeSelect(){
      if(!q('[data-gs-out]')) return;
      var appEl = q('[data-gs-app]'), lifeEl = q('[data-gs-life]'), colorEl = q('[data-gs-color]');
      var app  = appEl ? appEl.value : 'flat';
      var life = lifeEl ? parseInt(lifeEl.value, 10) : 6;
      var remEl = root.querySelector('[data-gs-rem]:checked');
      var rem = remEl ? remEl.value === 'yes' : false;
      var tier = colorEl ? colorEl.value : 'std';
      if(tier !== 'bw' && tier !== 'met') tier = 'std';

      /* Removable is a hard constraint: 631 is the only removable adhesive grade. */
      var list = rem ? ['631'] : (CAND[app] || CAND.flat);

      /* Cheapest candidate that actually meets the requested life for this colour tier. */
      var chosen = null, i;
      for(i = 0; i < list.length; i++){
        if(RATED[list[i]][tier] >= life){ chosen = list[i]; break; }
      }
      var shortfall = 0;
      if(!chosen){
        chosen = list[0];
        for(i = 1; i < list.length; i++){
          if(RATED[list[i]][tier] > RATED[chosen][tier]) chosen = list[i];
        }
        shortfall = life - RATED[chosen][tier];
      }

      var g = G[chosen];
      setText('[data-gs-out]', g.n);
      setText('[data-gs-film]', g.f);
      setText('[data-gs-thick]', g.t);
      setText('[data-gs-adh]', g.a);
      setText('[data-gs-dur]', g.d);
      setText('[data-gs-temp]', g.tp);

      var tierName = tier === 'bw' ? 'black or white' : (tier === 'met' ? 'metallic' : 'standard colour');
      var v = q('[data-gs-verdict]');
      if(!v) return;

      var title, cls, msg;

      if(shortfall > 0 && rem){
        title = 'Nothing in the line does this';
        cls = ' is-stop';
        msg = 'You asked for ' + life + ' years <em>and</em> clean removal. ORACAL 631 is the only removable adhesive grade and ORAFOL rates it 3 years, so it falls ' +
              shortfall + ' years short. There is no ORACAL adhesive film that gives you both. Your real options: accept 3 years with 631, accept a permanent film and gain the life, or look at ORAJET 3169RA on the printable side — removable, 5 years unprinted, with ORAFOL stating you can achieve clean residue-free removals within 3 years on most smooth sealed surfaces.';
      } else if(shortfall > 0){
        title = 'Best available, but it is ' + shortfall + ' year' + (shortfall > 1 ? 's' : '') + ' short';
        cls = ' is-stop';
        msg = g.n + ' is the longest-rated grade ORAFOL lists for this application, but in ' + tierName + ' it is rated ' +
              RATED[chosen][tier] + ' years against the ' + life + ' you asked for. ' +
              (tier === 'met'
                ? 'Metallics carry the shortest rating in every grade — if the life matters more than the finish, quote it in a standard colour or black and white instead.'
                : 'Either shorten the expectation or change the specification. Do not quote this as a ' + life + '-year job.');
      } else {
        title = 'Why this one';
        cls = '';
        msg = g.n + ' is rated ' + RATED[chosen][tier] + ' years in ' + tierName +
              ', which covers the ' + life + ' you asked for, and it is the least expensive grade in this application that does. ' +
              (APPNOTE[app] || '');
        if(rem){
          msg += ' Removal is clean because 631 uses a water-based removable adhesive — it is the grade that comes off painted drywall without taking the paint. Note ORAFOL also lists 631 for exterior signage, not interior only; the limit is the three years.';
        }
        if(chosen === '641'){
          cls = ' is-warn';
          msg += ' One caution: ORAFOL states plainly that 641 is not recommended for vehicle graphics.';
        }
      }

      if(tier === 'met' && shortfall === 0){
        msg += ' Note that a few specific colours rate 3 years regardless of grade — 651 brilliant blue, 751C new gold metallic (930), 970RA bronze, copper and graphite — so check the actual colour before you quote.';
      }

      v.className = 'swvt-verdict' + cls;
      v.innerHTML = '<strong>' + title + '</strong>' + msg;
    }

    /* ---------------- 3. FORMAT OPTIMIZER ---------------- */
    function formatOpt(){
      if(!q('[data-fo-win]')) return;
      var aw = num(q('[data-fa-w]')), al = num(q('[data-fa-l]')), ap = num(q('[data-fa-p]'));
      var bw = num(q('[data-fb-w]')), bl = num(q('[data-fb-l]')), bp = num(q('[data-fb-p]'));
      var waste = num(q('[data-f-waste]')) / 100;
      if(waste < 0) waste = 0;
      if(waste > 0.9) waste = 0.9;

      var aArea = (aw * al * 36) / 144, bArea = (bw * bl * 36) / 144;
      var aUse = aArea * (1 - waste), bUse = bArea * (1 - waste);
      var aC = aUse > 0 ? ap / aUse : 0, bC = bUse > 0 ? bp / bUse : 0;

      setText('[data-fo-a]', aC > 0 ? money(aC) + ' / sq ft' : '—');
      setText('[data-fo-b]', bC > 0 ? money(bC) + ' / sq ft' : '—');
      setText('[data-fo-aa]', fmt(aArea, 1) + ' sq ft (' + fmt(aUse, 1) + ' usable)');
      setText('[data-fo-ba]', fmt(bArea, 1) + ' sq ft (' + fmt(bUse, 1) + ' usable)');

      var v = q('[data-fo-verdict]');
      if(aC <= 0 || bC <= 0){
        setText('[data-fo-win]', '—');
        setText('[data-fo-diff]', '—');
        if(v){ v.className = 'swvt-verdict is-warn'; v.innerHTML = '<strong>Need both prices</strong>Enter a width, length and price for each option.'; }
        return;
      }
      var win = aC < bC ? 'Option A' : 'Option B';
      var lo = Math.min(aC, bC), hi = Math.max(aC, bC);
      var pct = ((hi - lo) / hi) * 100;
      setText('[data-fo-win]', win);
      setText('[data-fo-diff]', money(hi - lo) + ' / sq ft (' + fmt(pct, 1) + '%)');

      if(!v) return;
      var bigIsA = aArea > bArea;
      var bigLabel = bigIsA ? 'A' : 'B';
      var bigCost = bigIsA ? aC : bC, smallCost = bigIsA ? bC : aC;
      v.className = 'swvt-verdict';
      if(pct < 2){
        v.innerHTML = '<strong>Effectively a tie</strong>Under 2% apart per square foot. Buy on cash flow and shelf space instead — the smaller roll ties up less working capital and goes stale less often.';
      } else if(bigCost < smallCost){
        v.innerHTML = '<strong>The bigger roll wins by ' + fmt(pct, 1) + '%</strong>Option ' + bigLabel + ' is cheaper per usable square foot. That advantage is only real if you consume the roll before it ages out and if your layouts actually use the width — a wide roll cut for narrow work throws the saving straight in the bin.';
      } else {
        v.innerHTML = '<strong>The smaller roll wins by ' + fmt(pct, 1) + '%</strong>Unusual, and worth double-checking the prices. When it happens it is normally a promotion on the smaller format — buy it while it lasts.';
      }
    }

    /* ---------------- 4. ROLL YIELD ---------------- */
    function rollYield(){
      if(!q('[data-y-out]')) return;
      var W = num(q('[data-y-w]')), Lyd = num(q('[data-y-l]')), P = num(q('[data-y-p]'));
      var pw = num(q('[data-y-pw]')), ph = num(q('[data-y-ph]')), gap = num(q('[data-y-gap]'));
      var L = Lyd * 36;
      var area = (W * L) / 144;
      setText('[data-y-area]', fmt(area, 1) + ' sq ft');

      if(W <= 0 || L <= 0 || pw <= 0 || ph <= 0){
        setText('[data-y-out]', '—'); setText('[data-y-cost]', '—');
        setText('[data-y-across]', '—'); setText('[data-y-down]', '—'); setText('[data-y-util]', '—');
        return;
      }

      function fit(a, b){
        var across = Math.floor((W + gap) / (a + gap));
        var down = Math.floor((L + gap) / (b + gap));
        if(across < 0) across = 0;
        if(down < 0) down = 0;
        return { n: across * down, across: across, down: down };
      }
      var f1 = fit(pw, ph), f2 = fit(ph, pw);
      var rotated = f2.n > f1.n;
      var best = rotated ? f2 : f1;
      var n = best.n;

      setText('[data-y-out]', fmt(n, 0));
      setText('[data-y-across]', best.across + ' pcs' + (rotated ? ' (rotated)' : ''));
      setText('[data-y-down]', best.down + ' rows');
      setText('[data-y-cost]', n > 0 ? money(P / n) : '—');

      var used = (n * pw * ph) / 144;
      var util = area > 0 ? (used / area) * 100 : 0;
      setText('[data-y-util]', fmt(util, 1) + '% of roll used');

      var v = q('[data-y-verdict]');
      if(!v) return;
      if(n <= 0){
        v.className = 'swvt-verdict is-stop';
        v.innerHTML = '<strong>Nothing fits</strong>The piece is larger than the roll in at least one dimension. Check whether a wider roll, or a smaller gap, solves it.';
      } else if(util < 55){
        v.className = 'swvt-verdict is-stop';
        v.innerHTML = '<strong>' + fmt(util, 0) + '% yield — you are paying for waste</strong>Over ' + fmt(100 - util, 0) + '% of this roll becomes offcut at these dimensions. A different roll width, or ganging two jobs into one layout, is usually worth more than any price negotiation on the material.';
      } else if(util < 75){
        v.className = 'swvt-verdict is-warn';
        v.innerHTML = '<strong>' + fmt(util, 0) + '% yield</strong>Workable but not tight. Check whether a narrower roll nests this piece more cleanly before committing to a standing order.';
      } else {
        v.className = 'swvt-verdict';
        v.innerHTML = '<strong>' + fmt(util, 0) + '% yield — well matched</strong>This roll width suits this piece size. Worth noting on the job sheet so it gets reordered in the same format.';
      }
    }

    /* ---------------- wire up ---------------- */
    bind('[data-lh-dist]', letterHeight);
    bind('[data-lh-case]', letterHeight, 'change');
    bind('[data-lh-mode]', letterHeight, 'change');

    bind('[data-gs-app]', gradeSelect, 'change');
    bind('[data-gs-life]', gradeSelect, 'change');
    bind('[data-gs-color]', gradeSelect, 'change');
    bind('[data-gs-rem]', gradeSelect, 'change');

    ['[data-fa-w]','[data-fa-l]','[data-fa-p]','[data-fb-w]','[data-fb-l]','[data-fb-p]','[data-f-waste]']
      .forEach(function(s){ bind(s, formatOpt); });

    ['[data-y-w]','[data-y-l]','[data-y-p]','[data-y-pw]','[data-y-ph]','[data-y-gap]']
      .forEach(function(s){ bind(s, rollYield); });

    letterHeight(); gradeSelect(); formatOpt(); rollYield();
  });
})();
